import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ServiceQueueTableMessages = TableColumnsMessages &
  PopoverMessages & {
    idColumn: string;
    nameColumn: string;
    activeColumn: string;
    routingTypeColumn: string;
    slaColumn: string;
    userIdColumn: string;
    userNameColumn: string;
    userActiveColumn: string;
    yesLabel: string;
    noLabel: string;
    routingTypeCircular: string;
    routingTypeLeastAttendance: string;
  };

export const SERVICE_QUEUE_TABLE_MESSAGES: ServiceQueueTableMessages = {
  idColumn: "ID",
  nameColumn: "Nome",
  activeColumn: "Ativa",
  routingTypeColumn: "Tipo de distribuição",
  slaColumn: "SLA (min)",
  userIdColumn: "ID Usuário",
  userNameColumn: "Nome",
  userActiveColumn: "Ativo",
  yesLabel: "Sim",
  noLabel: "Não",
  routingTypeCircular: "Distribuição circular",
  routingTypeLeastAttendance: "Menor número de atendimentos",

  ...TABLE_COLUMNS_MESSAGES,
  ...POPOVER_MESSAGES,
};
